var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56.5957C43.464 56.5957 56 44.0597 56 28.5957C56 13.1317 43.464 0.595703 28 0.595703C12.536 0.595703 0 13.1317 0 28.5957C0 44.0597 12.536 56.5957 28 56.5957Z",
    fill: "#0C65F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.592 22.4258V33.4016C32.592 35.9102 30.2982 37.7126 28.1793 37.7126C24.4021 37.7126 23.5896 33.9883 23.5896 33.9883V22.4258H14.2373V34.5773C14.2373 41.9129 20.8153 45.2054 28.2568 45.2054C35.3065 45.2054 41.7627 41.9196 41.7627 34.5773V22.4258H32.592Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9499 19.0313V12.764L24.2863 15.1471L28.0135 12.5537L31.7991 15.1471L36.0725 12.7679V19.0313H19.9499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.4341478704272c9b66318c53d741c35d.svg";
export { ForwardRef as ReactComponent };